import React from "react";

import BaseSvg, { BaseSvgProps } from "../../BaseSvg";

const SlashingSvg: React.FunctionComponent<BaseSvgProps> = ({
  className = "",
  fillColor,
  secondaryFillColor,
}) => {
  return (
    <BaseSvg className={className} viewBox="0 0 19 17">
      <path
        fill={fillColor}
        d="M0,6s7.62,3.35,14.18,5.85l1-2.33,1.06.41-1.59,2.94L19,15.22l-.49,1.1-4.22-2.16L12.9,17l-1.31-.41,1-1.88S3.47,9.6,0,6Z"
      />
      <path fill={fillColor} d="M3,5A14.91,14.91,0,0,1,14,0S7.56.94,5,6Z" />
      <path
        fill={fillColor}
        d="M7,6.45a8.13,8.13,0,0,1,6-2.73S9.49,4.24,8.09,7Z"
      />
      <path
        fill={fillColor}
        d="M10,7.89A5.65,5.65,0,0,1,14.17,6a4.92,4.92,0,0,0-3.41,2.27Z"
      />
    </BaseSvg>
  );
};

export default SlashingSvg;
